import { render, staticRenderFns } from "./file_content_linked_wysiwyg.vue?vue&type=template&id=64991964&scoped=true&lang=pug"
import script from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"
export * from "./file_content_linked_wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./file_content_linked_wysiwyg.vue?vue&type=style&index=0&id=64991964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64991964",
  null
  
)

export default component.exports